// extracted by mini-css-extract-plugin
module.exports = {"popup":"myPopup_popup__1D_Wu","title":"myPopup_title__34ddE","content":"myPopup_content__3F3Bx"};